const linkLandingPagesValidationES = {
    "add": {
        "title": {
            "required": "El título es obligatorio",
            "length": "El título no puede tener más de 32 caracteres"
        },
        "short_description": {
            "length": "La descripción no puede tener más de 80 caracteres."
        },
        "back_url": {
            "required": "La URL de retorno es obligatoria",
            "length": "La URL de retorno no puede tener más de 10 caracteres",
            "unique": "¡Vaya! Esta URL de retorno ya está asociada con otra página de destino. Por favor, prueba con otra URL de retorno.",
            "available": "La URL de retorno está disponible",
            "invalid": "La URL de retorno no es válida"
        },
        "logo": {
            "required": "El logo es obligatorio",
            "dimensions": "El tamaño del logo debe ser al menos 500 X 500 px y la imagen debe tener una relación de aspecto 1:1, se admiten formatos JPG/JPEG/PNG.",
            "choose": "Por favor, elige una imagen",
            "file": "Por favor, sube formatos JPG o PNG, resolución mínima 500 X 500 px y la imagen debe tener una relación de aspecto 1:1. Tamaño máximo 2MB"
        },
        "background_image": {
            "dimensions": "El tamaño de la imagen de fondo debe ser al menos 1000 X 1000 px y la imagen debe tener una relación de aspecto 1:1, se admiten formatos JPG/JPEG/PNG.",
            "choose": "Por favor, elige una imagen",
            "file": "Por favor, sube formatos JPG o PNG, resolución mínima 1000 X 1000 px y la imagen debe tener una relación de aspecto 1:1. Tamaño máximo 5MB"
        },
        "social_link_destination_url_facebook": {
            "required": "La URL de destino es obligatoria",
            "regexp": "URL no válida",
            "invalid": "URL de Facebook no válida"
        },
        "social_link_destination_url_instagram": {
            "required": "La URL de destino es obligatoria",
            "regexp": "URL no válida",
            "invalid": "URL de Instagram no válida"
        },
        "social_link_destination_url_twitter": {
            "required": "La URL de destino es obligatoria",
            "regexp": "URL no válida",
            "invalid": "URL de Twitter no válida"
        },
        "social_link_destination_url_youtube": {
            "required": "La URL de destino es obligatoria",
            "regexp": "URL no válida",
            "invalid": "URL de Youtube no válida"
        },
        "social_link_destination_url_tiktok": {
            "required": "La URL de destino es obligatoria",
            "regexp": "URL no válida",
            "invalid": "URL de TikTok no válida"
        },
        "social_link_destination_url_linkedin": {
            "required": "La URL de destino es obligatoria",
            "regexp": "URL no válida",
            "invalid": "URL de LinkedIn no válida"
        },
        "social_link_destination_url_other": {
            "regexp": "URL no válida"
        },
        "featured_link_title": {
            "required": "La etiqueta es obligatoria",
            "length": "La etiqueta no puede exceder los 100 caracteres"
        },
        "featured_link_destination_url": {
            "required": "La URL de destino es obligatoria",
            "regexp": "URL no válida"
        }
    },
    "update": {
        "title": {
            "required": "El título es obligatorio",
            "length": "El título no puede tener más de 32 caracteres"
        },
        "short_description": {
            "length": "La descripción no puede tener más de 80 caracteres."
        },
        "back_url": {
            "required": "La URL de retorno es obligatoria",
            "length": "La URL de retorno no puede tener más de 10 caracteres",
            "unique": "¡Vaya! Esta URL de retorno ya está asociada con otra página de destino. Por favor, prueba con otra URL de retorno.",
            "available": "La URL de retorno está disponible",
            "invalid": "La URL de retorno no es válida"
        },
        "logo": {
            "required": "El logo es obligatorio",
            "dimensions": "El tamaño del logo debe ser al menos 500 X 500 px y la imagen debe tener una relación de aspecto 1:1, se admiten formatos JPG/JPEG/PNG.",
            "choose": "Por favor, elige una imagen",
            "file": "Por favor, sube formatos JPG o PNG, resolución mínima 500 X 500 px y la imagen debe tener una relación de aspecto 1:1. Tamaño máximo 2MB"
        },
        "background_image": {
            "dimensions": "El tamaño de la imagen de fondo debe ser al menos 1000 X 1000 px y la imagen debe tener una relación de aspecto 1:1, se admiten formatos JPG/JPEG/PNG.",
            "choose": "Por favor, elige una imagen",
            "file": "Por favor, sube formatos JPG o PNG, resolución mínima 1000 X 1000 px y la imagen debe tener una relación de aspecto 1:1. Tamaño máximo 5MB"
        },
        "social_link_destination_url_facebook": {
            "required": "La URL de destino es obligatoria",
            "regexp": "URL no válida",
            "invalid": "URL de Facebook no válida"
        },
        "social_link_destination_url_instagram": {
            "required": "La URL de destino es obligatoria",
            "regexp": "URL no válida",
            "invalid": "URL de Instagram no válida"
        },
        "social_link_destination_url_twitter": {
            "required": "La URL de destino es obligatoria",
            "regexp": "URL no válida",
            "invalid": "URL de Twitter no válida"
        },
        "social_link_destination_url_youtube": {
            "required": "La URL de destino es obligatoria",
            "regexp": "URL no válida",
            "invalid": "URL de Youtube no válida"
        },
        "social_link_destination_url_tiktok": {
            "required": "La URL de destino es obligatoria",
            "regexp": "URL no válida",
            "invalid": "URL de TikTok no válida"
        },
        "social_link_destination_url_linkedin": {
            "required": "La URL de destino es obligatoria",
            "regexp": "URL no válida",
            "invalid": "URL de LinkedIn no válida"
        },
        "social_link_destination_url_other": {
            "regexp": "URL no válida"
        },
        "featured_link_title": {
            "required": "La etiqueta es obligatoria",
            "length": "La etiqueta no puede exceder los 100 caracteres"
        },
        "featured_link_destination_url": {
            "required": "La URL de destino es obligatoria",
            "regexp": "URL no válida"
        }
    }
};

export default linkLandingPagesValidationES;